<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <div class="m-2">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <!-- Per Page -->
          <list-per-page
            :total="total"
            :current-per-page="perPage"
            @onChangePerPage="changePerPage"
          />
        </b-col>
        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <list-search @onSearch="search" />
          </div>
        </b-col>
      </b-row>
    </div>
    <table-loader v-if="loader" />
    <affiliate-users-list
      v-else
      :fields="fields"
      :items="items"
      :sort-key="sortKey"
      :sort-type="sortType"
      :additional-data="additionalData"
      :list-filters="additionalData.filters"
      :filters="filters"
      @onSortByChange="changeSortKey"
      @onSortDescChange="changeSortType"
      @onFilterChange="filterChange"
      @onFilterButtonClicked="getData"
    />

    <list-pagination
      :current="page"
      :current-per-page="perPage"
      :from="from"
      :to="to"
      :total="total"
      :total-page="totalPage"
      @onChangePage="changePage"
    />
  </b-card>
</template>

<script>
import { ListIndex } from '../../common/mixins/list'
import AffiliateUsersList from '../../components/affiliate-users/list/AffiliateUsersList'

export default {
  components: {
    AffiliateUsersList,
  },
  mixins: [ListIndex],
  data() {
    return {
      routeName: 'affiliate-users',
      sortKey: 'created_at',
      sortType: true,
      userFields: [
        {
          key: 'user.name',
          label: this.$t('User'),
        },
        {
          key: 'count',
          label: this.$t('Sales count'),
        },
        {
          key: 'total_amount',
          label: this.$t('Sales amount'),
        }, {
          key: 'total_commission',
          label: this.$t('Total commission'),
        },
        {
          key: 'created_at',
          label: this.$t('Created at'),
          sortable: true,
        },
      ],
      adminFields: [
        {
          key: 'user.name',
          label: this.$t('User'),
        },
        {
          key: 'count',
          label: this.$t('Sales count'),
        },
        {
          key: 'total_amount',
          label: this.$t('Sales amount'),
        }, {
          key: 'total_commission',
          label: this.$t('Total commission'),
        },
        {
          key: 'invited_user.name',
          label: this.$t('Invited user'),
        },
        {
          key: 'created_at',
          label: this.$t('Created at'),
          sortable: true,
        },
      ],
    }
  },
  created() {
    if (this.$route.name === 'users-show') {
      this.customParams.user_id = this.$route.params.id
    }
  },
}
</script>

<style lang="scss">

</style>
